import { useQuery } from '@apollo/client'
import { PaginationBar } from '@components/PaginationBar'
import { useDebounce } from '@hooks/useDebounce'
import { usePageSize } from '@hooks/usePageSize'
import React, { useState } from 'react'
import { GET_POSTS_UPERCUT } from '../schema/blog'
import BlogFilter from './BlogFilter'
import BlogTableOrganisms from './BlogTableOrganisms'

type Props = {
    readOnly?: boolean;
}

const BlogList = ({ readOnly }: Props) => {

    const [query, setQuery] = useState('');
    const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
    const { pageSize, storePageSize } = usePageSize({
        defaultPageSize: 12,
        storageKey: 'blog-list-page-size',
    });

    const [pagination, setPagination] = useState({
        offset: 0,
        limit: pageSize,
    });

    const debouncedQuery = useDebounce(query, 500);

    const { data, loading } = useQuery(GET_POSTS_UPERCUT, {
        variables: {
            query: debouncedQuery,
            pagination: {
                offset: pagination.offset,
                limit: pagination.limit,
            }
        },
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
    });

    return (
        <>
            <BlogFilter
                viewMode={viewMode}
                totalDocs={data?.getPostsUpercut?.meta?.totalDocs || 0}
                changeViewMode={function (event: React.MouseEvent<HTMLButtonElement>): void {
                    setViewMode(event.currentTarget.value as 'grid' | 'list');
                }} onQueryChange={function (query: string): void {
                    setQuery(query);
                }} />

            <BlogTableOrganisms
                viewMode={viewMode}
                data={data?.getPostsUpercut?.docs || []}
                loading={loading}
                readOnly={readOnly}
                onConfirm={function (params: { title: string; description: string }): void {
                    console.log('Function not implemented.')
                }}
                setSelectedId={function (id: string): void {
                    console.log('Function not implemented.')
                }}
            />

            <PaginationBar
                totalPages={data?.getPostsUpercut?.meta?.totalPages || 0}
                currentPage={pagination.offset / pagination.limit + 1}
                itemsPerPage={pagination.limit}
                setCurrentPage={page => {
                    setPagination(prev => ({
                        ...prev,
                        offset: page === 1 ? 0 : (page - 1) * prev.limit,
                    }));
                }}
                setItemsPerPage={limit => {
                    storePageSize(limit);
                    setPagination(prev => ({
                        ...prev,
                        limit,
                        offset: 0,
                    }));
                }}
            />
        </>
    )
}

export default BlogList
